import { SearchOutlined } from '@ant-design/icons';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { HeaderTitle, SearchMedicalInstitution, Pagination } from 'components';
import { RootState } from '../../store';
import { MedicalSearchRequest } from '../../types';
import TableMedical from './TableMedical';
import { resetSearchValue, setCurrentPage, setSearchValue } from './slice';
import Wrap from './styles';
import { getListMedical } from './thunk';

const ListMedicalInstitution: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { totalItems, items, currentPage, searchValue } = useSelector((state: RootState) => state.medicals);

  useEffect(() => {
    dispatch(getListMedical({ pageNumber: currentPage, searchValue: searchValue }));
  }, [dispatch, currentPage, searchValue]);

  useEffect(() => {
    return () => {
      if (history.location.pathname !== '/medical_institution/detail') {
        dispatch(resetSearchValue());
      }
    };
  }, [history.location.pathname, dispatch]);

  const onChangeValueSearch = (values: MedicalSearchRequest | undefined) => {
    dispatch(setSearchValue(values));
    dispatch(setCurrentPage(1));
  };
  const onChangePage = (page: number) => {
    dispatch(setCurrentPage(page));
  };
  return (
    <Wrap>
      <HeaderTitle title="医療機関一覧" icon={SearchOutlined} />
      <SearchMedicalInstitution onSearch={onChangeValueSearch} />
      <div className="section">
        <Pagination totalItems={totalItems} page={currentPage} onChangePage={onChangePage} />
        <div className="table">
          <TableMedical data={items} />
        </div>
      </div>
    </Wrap>
  );
};

export default ListMedicalInstitution;
